import { resolveAppIdFromPathname, appRegistryEntryById } from '../apps/appsRegistry';

/**
 * Shown in the browser tab when no app workspace is matched — e.g. the login,
 * signup or app-picker screens. This is the neutral company brand.
 */
export const APP_BROWSER_TITLE = 'Corbis ERP';

/** Routes that must always show the company brand rather than an app title. */
const BRAND_ONLY_PREFIXES = ['/login', '/signup', '/select-app'];

/** Returns the active app's adminTitle based on the given pathname (defaults to current URL). */
export function resolveAppBrowserTitle(pathname?: string): string {
    const path = pathname ?? window.location.pathname;

    // Login / signup / app-picker → company brand, not any single app.
    if (BRAND_ONLY_PREFIXES.some(p => path === p || path.startsWith(`${p}/`))) {
        return APP_BROWSER_TITLE;
    }

    const appId = resolveAppIdFromPathname(path);
    if (appId) {
        const entry = appRegistryEntryById(appId);
        if (entry?.adminTitle) return entry.adminTitle;
        if (entry?.name) return entry.name;
    }
    return APP_BROWSER_TITLE;
}
